import { TOPICS } from "./topics";
import type { AiResponse, AiSearchContext } from "./types";

// Scores every topic by keyword overlap against the query (longer, more
// specific keyword phrases score higher than single generic words) and
// hands off to the best-scoring topic's own buildResponse, which decides
// which blocks actually apply to *this* phrasing of the question — not a
// fixed template per topic. Below the threshold, returns null so the UI
// can show an honest "out of scope" fallback rather than a guess.
const MATCH_THRESHOLD = 1;

export function planAiResponse(query: string, ctx: AiSearchContext): AiResponse | null {
  const trimmed = query.trim();
  if (!trimmed) return null;
  const q = trimmed.toLowerCase();

  let best: { score: number; topic: (typeof TOPICS)[number] } | null = null;
  for (const topic of TOPICS) {
    let score = 0;
    for (const keyword of topic.keywords) {
      if (q.includes(keyword)) score += keyword.split(" ").length;
    }
    if (score > 0 && (!best || score > best.score)) {
      best = { score, topic };
    }
  }

  if (!best || best.score < MATCH_THRESHOLD) return null;
  return best.topic.buildResponse(trimmed, ctx);
}
